var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-container" }, [
    _c(
      "div",
      { staticClass: "sidebar" },
      [
        _c("SideBar", {
          attrs: { firms: _vm.firms },
          on: { getFirmData: _vm.getFirmAttestationSubmissionStatus },
        }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "attestation-submission-status-list" },
      [
        _c(
          "div",
          { staticClass: "manager" },
          [
            _vm._m(0),
            _c("sui-input", {
              attrs: {
                placeholder: "Search persons",
                icon: "search",
                "icon-position": "left",
              },
              model: {
                value: _vm.searchPhrase,
                callback: function ($$v) {
                  _vm.searchPhrase = $$v
                },
                expression: "searchPhrase",
              },
            }),
          ],
          1
        ),
        _c("AttestationSubmissionStatusList", {
          attrs: {
            "attestation-submission-status": _vm.attestationsSubmissionStatus,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "title" }, [
      _c("span", [_c("h2", [_vm._v("Attestation Submission Status")])]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }